import { trackEvent } from '@/utils/analytics';
import type { PhonePlacement } from '@/types/analytics-events';

export const BUSINESS_NAME = 'Zeera By The Bay';

export const PHONE = {
  display: '905-492-4400',
  href: 'tel:9054924400',
  international: '+1-905-492-4400',
};

export const EMAIL = 'contact@zeeraindiancuisine.ca';

export const ADDRESS = {
  street: '713 Krosno Blvd',
  city: 'Pickering',
  province: 'ON',
  postalCode: 'L1W 1G4',
  country: 'CA',
};

const GOOGLE_PLACE_ID = 'ChIJVS4HEeve1IkR-7pfhpIwgGs';
const ENCODED_NAME = encodeURIComponent(BUSINESS_NAME);

export const GOOGLE_MAPS_URL = `https://www.google.com/maps/search/?api=1&query=${ENCODED_NAME}&query_place_id=${GOOGLE_PLACE_ID}`;
export const DIRECTIONS_URL = `https://www.google.com/maps/dir/?api=1&destination=${ENCODED_NAME}&destination_place_id=${GOOGLE_PLACE_ID}`;
export const WRITE_REVIEW_URL = `https://search.google.com/local/writereview?placeid=${GOOGLE_PLACE_ID}`;
export const MAP_EMBED_URL = `https://www.google.com/maps/embed/v1/place?q=place_id:${GOOGLE_PLACE_ID}&key=${process.env.GATSBY_GOOGLE_MAPS_API_KEY}`;

export const getPhoneLinkProps = (placement: PhonePlacement) => ({
  href: PHONE.href,
  onClick: () => trackEvent('phone_click', { placement }),
});
